import axiosInstance from '@/api/axios'

// 阳光保险隐私协议
export function agreement(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/web/agreement/queryAgreement',
        // method: 'post',
        // data: parameter,
        method: 'get',
        params: parameter,
    })
}

// 阳光保险隐私协议-不加密
export function agreementNoEncrypt(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/web/agreement/queryAgreement/plaintext',
        // method: 'post',
        // data: parameter,
        method: 'get',
        params: parameter,
    })
}

export function agreement1(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/web/agreement/queryAgreement1',
        method: 'post',
        data: parameter,
    })
}

// 阳光保险获取隐私协议编码
export function agreementsVersion(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/web/agreement/agreementsVersion',
        method: 'get',
        params: parameter,
    })
}

// 更新用户签署协议版本
export function synUserAgreeVersion(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/synUserAgreeVersion',
        method: 'POST',
        data: parameter,
    })
}
